// store/slices/authSlice.js - Authentication state slice

export const createAuthSlice = (set) => ({
  // State
  user: null,
  isAuthenticated: false,

  // Actions
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  logout: () => set({ user: null, isAuthenticated: false }),
});
